interface LogoProps {
  className?: string;
}

export function NewTechnologiesLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M20.6,12.4c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1,3.1-1.4,3.1-3.1-1.4-3.1-3.1-3.1M20.6,17c-.9,0-1.5-.7-1.6-1.5s.7-1.6,1.5-1.6h0c.9,0,1.5.7,1.5,1.5s-.7,1.5-1.5,1.5" 
      />
      <path 
        fill="currentColor" 
        d="M29.4,12.4c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1,3.1-1.4,3.1-3.1-1.4-3.1-3.1-3.1M29.4,17c-.9,0-1.5-.7-1.6-1.5s.7-1.6,1.5-1.6h0c.9,0,1.5.7,1.5,1.5s-.7,1.5-1.5,1.5" 
      />
      <path 
        fill="currentColor" 
        d="M38.8,16c-.3-1.8-1.8-3.2-3.7-3.5-.5-1.9-2-3.5-4.9-3.5h-4.5v-1.7c1.4-.4,2.1-1.9,1.7-3.2-.4-1.3-1.9-2.1-3.2-1.7-1.4.4-2.1,1.9-1.7,3.2.2.8.9,1.4,1.7,1.7v1.7h-4.5c-2.1,0-4.3,1-4.9,3.5-2.4.3-4,2.5-3.7,4.8.2,1.8,1.7,3.3,3.5,3.6h0c.2,3.4,2.7,4.7,5.1,4.7h10.5c3.5,0,4.9-2.3,5.1-4.6,2.3-.4,3.9-2.7,3.5-5h0M14.6,19.4c-1.5-.4-2.3-1.9-1.9-3.4.3-.9,1-1.6,1.9-1.9v5.3h0ZM24,4.9c0-.6.5-1,1-1s1,.5,1,1-.5,1-1,1h0c-.6,0-1-.5-1-1M33.8,20.4c0,1.3-.5,3.6-3.6,3.6h-10.5c-1.3,0-3.6-.5-3.6-3.6v-6.3c0-3.1,2.2-3.6,3.6-3.6h10.5c3.1,0,3.6,2.2,3.6,3.6v6.3h0ZM35.3,19.4v-5.3c1.5.4,2.3,1.9,1.9,3.4-.3.9-1,1.6-1.9,1.9h0Z" 
      />
      <path 
        fill="currentColor" 
        d="M29.4,20.7h-8.8c-.4,0-.8.4-.8.8,0,.4.3.7.8.8h8.8c.4,0,.8-.3.8-.8s-.3-.8-.8-.8h0" 
      />
      <path 
        fill="currentColor" 
        d="M42.2,27h0c0-1.6-1.4-3-3-3-1.4,0-2.6,1-2.9,2.3l-2.1.4H15.8l-2.1-.4c-.4-1.6-1.9-2.6-3.6-2.3-1.6.4-2.6,2-2.3,3.6.2,1.1,1.1,2,2.2,2.2v5.8c-1.3.3-2.2,1.5-2.2,2.9v1.4c0,.4.4.8.8.8.4,0,.7-.3.8-.8v-1.4c0-.8.6-1.5,1.4-1.5.8,0,1.5.6,1.5,1.4h0v1.5c0,.4.4.8.8.8.4,0,.7-.3.8-.8v-1.4c0-1.3-.9-2.5-2.2-2.9v-5.8c1-.3,1.8-1,2.1-2l1.3.2v9.5c0,1.4.3,2.8.9,4h0c2.3,5.1,8.2,7.4,13.3,5.1,2.2-1,4-2.8,5-5h0c.6-1.4.9-2.7.9-4.1v-9.5l1.3-.2c.3,1,1.1,1.7,2.1,2v5.8c-1.3.3-2.2,1.5-2.2,2.9v1.4c0,.4.4.8.8.8.4,0,.7-.3.8-.8v-1.4c0-.8.7-1.4,1.5-1.4.8,0,1.4.6,1.4,1.4v1.4c0,.4.4.8.8.8.4,0,.7-.3.8-.8v-1.4c0-1.3-.9-2.5-2.2-2.9v-5.8c1.3-.3,2.2-1.5,2.2-2.9M10.8,28.5c-.8,0-1.4-.6-1.4-1.5s.6-1.5,1.4-1.5,1.4.6,1.4,1.5-.6,1.5-1.4,1.5M25,46.2c-2.9,0-5.6-1.5-7.2-3.9h14.3c-1.6,2.5-4.3,3.9-7.2,3.9M33.5,37.7c0,1-.2,2-.6,3h-15.9c-.4-1-.6-2-.6-3v-9.4h17v9.4h0ZM39.2,28.5h0c-.4-.4-.4-1.1,0-1.5.4-.4,1-.4,1.4,0,.4.4.4,1,0,1.4-.4.4-1,.4-1.4,0" 
      />
      <path 
        fill="currentColor" 
        d="M27.7,33.8c-.1-.1-.3-.2-.5-.2h-2.3l2.8-2.9c.3-.3.2-.8-.1-1.1-.3-.2-.7-.2-1,0l-4.1,4.2c-.3.3-.3.8,0,1.1.1.1.3.2.5.2h2.4l-2.9,3.2c-.3.3-.3.8,0,1.1.3.3.8.3,1.1,0l4.1-4.5c.3-.3.2-.8,0-1.1" 
      />
    </svg>
  );
}